import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import React__default, { useRef, useState, useEffect } from 'react';
import './Segment.scss.js';
import { classnames } from '../../../utils/classnames.js';

var Segment = function Segment(_ref) {
  var list = _ref.list,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      value = _ref.value,
      onChange = _ref.onChange;
  var slider = useRef(null);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var setBoundary = function setBoundary(i) {
    if (slider.current) {
      slider.current.style.transform = "translateX(".concat(100 * i, "%)");
    }
  };

  useEffect(function () {
    if (!value) {
      return;
    }

    var index = list.findIndex(function (o) {
      return o.value === value.value;
    });
    setActiveIndex(index < 0 ? 0 : index);
  }, [value]);
  useEffect(function () {
    setBoundary(activeIndex);
  }, [activeIndex]); // -------------------------------------------------------------------------------------------------------------------

  var handleChange = function handleChange(i) {
    if (list[i].disabled) {
      return;
    }

    setActiveIndex(i);
    onChange(list[i]);
  }; // -------------------------------------------------------------------------------------------------------------------


  return /*#__PURE__*/React__default.createElement("div", {
    className: "rf-segment",
    "data-v-6e52f9c7": ""
  }, /*#__PURE__*/React__default.createElement("div", {
    className: classnames('rf-segment__list', fullWidth && 'rf-segment__list--full'),
    "data-v-6e52f9c7": ""
  }, list.map(function (o, i) {
    return /*#__PURE__*/React__default.createElement("button", {
      key: o.value,
      className: classnames('rf-segment__item', activeIndex === i && 'rf-segment__item--active'),
      type: "button",
      disabled: o.disabled,
      onClick: function onClick() {
        return handleChange(i);
      },
      "data-v-6e52f9c7": ""
    }, !!o.icon && /*#__PURE__*/React__default.createElement("div", {
      className: "rf-segment__icon",
      "data-v-6e52f9c7": ""
    }, o.icon), o.label);
  })));
};

export { Segment as default };
